import React from "react";
import { Badge } from "@mui/material";
import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router';

export default function Notification() {
  const [notif, setNotif] = React.useState([]);
  const [show, setShow] = React.useState(false)
  const [cookies, setCookie] = useCookies(['accessToken']);
  const navigate = useNavigate();
  let color

  React.useEffect(() => {
    const validateAccessToken = async () => {
      try {
        const url = 'https://w-shop-backend.vercel.app/api/notifications';
        const rawResponse = await fetch(url, {
          method: 'GET',
          headers: {
            'Content-type': 'application/json',
            'Authorization': 'Bearer ' + cookies.accessToken,
          },
        })
        const response = await rawResponse.json();
        if (response.status !== 'success') {
          throw new Error();
        } else {
          setNotif(response.data)
        }
      } catch (error) {
        setCookie('accessToken', '', { path: '/' });
      }
    }
    validateAccessToken();
  }, [cookies.accessToken, setCookie])

  const isRead = async (idNotif) => {
    try {
      console.log(idNotif);
      // setIsLoading(true);
      const url = `https://w-shop-backend.vercel.app/api/notifications/${idNotif}/read`;
      const rawResponse = await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-type': 'application/json',
          'Authorization': 'Bearer ' + cookies.accessToken,
        },
        // body: JSON.stringify(idNotif)
      });
      const response = await rawResponse.json(); console.log(response);
      if (response.status !== 'success') {
        throw new Error(response.message);
      } else {
        navigate(0)
      }

    } catch (error) {
      console.log(error);
    }
  }

  const notifRead = []
  for (let i = 0; i < notif.length; i++) {
    if (notif[i].isRead === false) {
      notifRead.push(notif[i])
    }
  }
  return (
    <button className=" ms-auto  bg-transparent border-0 me-2" >

      <Badge badgeContent={notifRead.length} color="error" className="navbar-top" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
        <img src={"/img/icon-notification.png"} className="img-navbar-top me-2 mb-1" alt="" />
        Notifikasi
      </Badge>
      <ul className="dropdown-menu p-0 d-borderbox " style={{width:'250px', maxHeight: "200px", overflow: 'hidden', overflowY: 'scroll' }} >
        {(show === false ? (
          <div className='user-select-none text-center py-2' onClick={() => { setShow(true) }}>Tampilkan semua</div>
        ) : (
          <div className='user-select-none text-center py-2' onClick={() => { setShow(false) }}>Sembunyikan</div>))}
        {
          (show === false) ? (
            notif.slice(0, 5).map((not, index) => {
              not.isRead === false ? (color = 'rgba(0, 102, 255, 0.15)') : (color = 'white')
              return (
                <li key={index} className='px-2 pb-1 border-top' style={{ fontSize: "12px", backgroundColor: color }}>
                  {not.message}
                  <div className='text-primary text-end user-select-none' onClick={() => { isRead(not.id) }}>sudah dibaca</div>
                </li>)
            })
          ) : (
            notif.map((not, index) => {
              not.isRead === false ? (color = 'rgba(0, 102, 255, 0.15)') : (color = 'white')
              return (<li key={index} className='px-2 pt-1' style={{ fontSize: "12px", backgroundColor: color }}>
                {not.message}
                <div className='text-primary text-end user-select-none' onClick={() => { isRead(not.id) }}>sudah dibaca</div>
              </li>)
            }))
        }
      </ul>
    </button>
  );
}
